module.exports = __webpack_public_path__ + "img/ZxPay.93a68202.png";